import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import DoodleBackground from '../../../../components/doodle-background'
import styles from './mission.module.scss'

export default function Mission() {
  return (
    <div className={styles.root}>
      <DoodleBackground className={styles.doodle} variant="bottomLeft" />
      <div className={styles.outer}>
        <div className={styles.inner}>
          <FormattedMessage defaultMessage="Vårt mission" id="press.mission.heading" tagName="h2" />
          <FormattedMessage
            defaultMessage="Dooer är en modern fullservicebyrå med smarta bokföringstjänster och intelligenta lösningar för företagare. Vi tänker att det ska vara enkelt, roligt och lönsamt att driva företag. Du ska inte behöva vara ekonom för det. Vi fortsätter att påverka och utmana föråldrade sätt och system för att förändra bokföringsbranschen som vi känner till den idag. Vi tror nämligen på en modern och automatiserad bokföring. Utvecklad för företagare själva."
            id="press.mission.lede"
            tagName="p"
          />
        </div>
      </div>
    </div>
  )
}
